export const BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  "https://dev.backend.bpo24.osring.com/api/v1";

export const DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const CORS_HEADERS = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  "Access-Control-Allow-Headers": "Content-Type, Authorization",
};

export const API_TIMEOUT = 20000; // 10 seconds
